import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Section6 from "./Section6";

export default function AiInEcommerce() {
  return (
    <div className="Ai-In-Ecommerce pt-[160px] sm:pt-0">
      <Helmet>
        <title>AI In Ecommerce - Mean3 Software Solutions</title>
        <meta
        name="description"
        content="Mean3 integrates AI into e-commerce to enhance user experience, boost conversions, and automate operations for next-level growth."
        />
      </Helmet>      
      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
      <Section6 />
    </div>
  );
}
